module.exports = __webpack_public_path__ + "static/img/产业链——科技创新@2x.a9fb47e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/产业链——科技创新@2x.png
// module id = 4AuA
// module chunks = 0